export const GET_DOMAIN_DATA_REQUEST = 'domain/GET_DOMAIN_DATA_REQUEST';
export const GET_DOMAIN_DATA_FAILURE = 'domain/GET_DOMAIN_DATA_FAILURE';
export const GET_DOMAIN_DATA_SUCCESS = 'domain/GET_DOMAIN_DATA_SUCCESS';